import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalUnits: 0,
  totalRecords: 0,
};

const buildingStats = createSlice({
  name: "buildingStats",
  initialState,
  reducers: {
    setBuildingStats: {
      prepare({ totalUnits, totalRecords }) {
        return {
          payload: { totalUnits, totalRecords },
        };
      },
      reducer(state, action) {
        state.totalUnits = action.payload.totalUnits;
        state.totalRecords = action.payload.totalRecords;
      },
    },
  },
});

export const { setBuildingStats } = buildingStats.actions;

export default buildingStats.reducer; 